import {v4 as uuid} from 'uuid';

import {
  ADD_HABIT,
  REMOVE_HABIT, 
  MARK_COMPLETED, 
  UNDO_COMPLETED, 
  SET_RECURRENCE,
  HABIT_TYPE,
  SET_ID,
  START_FETCH_HABITS,
  ERROR_FETCH_HABITS
} from "./constants";

import {
  DONE_FETCH_HABITS, DONE_SAVING_HABIT
} from '../Request/constants'

const initialState = [
    {
      uuid: uuid(),
      id: uuid(),
      name: 'Coding', 
      type: HABIT_TYPE.DO, 
      recurrence: [0,1,3,4,5,6],
      color: 'red-400',
      created_at: new Date()
    },
    {
      uuid: uuid(),
      id: uuid(),
      name: 'Journaling', 
      type: HABIT_TYPE.DO,
      recurrence: [0,1,2,6],
      color: 'green-400',
      created_at: new Date()
    },
    {
      uuid: uuid(),
      id: uuid(),
      name: 'Read a Book', 
      type: HABIT_TYPE.DO,
      recurrence: [0,1,2,3,4,5,6],
      color: 'orange-400',
      created_at: new Date()
    },
    {
      uuid: uuid(),
      id: uuid(),
      name: 'Meditation', 
      type: HABIT_TYPE.DO,
      recurrence: [0,1,2,6],
      color: 'blue-400',
      created_at: new Date()
    },
    {
      uuid: uuid(),
      id: uuid(),
      name: 'Gaming', 
      type: HABIT_TYPE.DONT,
      recurrence: [0,1,2,6],
      color: 'red-800',
      created_at: new Date()
    }
]

export default function habitReducer(habits = initialState, action){

  switch(action.type){

    case DONE_FETCH_HABITS:
      return action.habits.map(habit => ({...habit, uuid: uuid()}));

    case DONE_SAVING_HABIT:
      return habits.map(habit => habit.uuid === action.habit.uuid ? action.habit : habit);

    // received habit from database
    case SET_ID:
      return habits.map(habit => habit.uuid === action.uuid ? {...habit, id: action.id} : habit);

    // optimistic add habit 
    case ADD_HABIT:
      return [...habits, action.habit];

    case REMOVE_HABIT:
      return habits.filter(h => h.id !== action.id);

    case SET_RECURRENCE:
      return habits.map(h => h.id !== action.id ? h : {...h, recurrence: action.recurrence});
  }

  return habits;
}
